import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AnnotationType } from '../../types/annotation'

type SelectOption = {
  value: string
  label: string
}

const getOption = (
  options: SelectOption[],
  value?: string
): SelectOption | undefined => options.find((o) => o.value === value)

const AnnotationStatusFilter = ({
  initialValue,
  onChange,
  annotationType,
}: {
  initialValue?: string
  onChange: (v: SelectOption | null) => void
  annotationType?: AnnotationType
}) => {
  const { t } = useTranslation()

  const options = [
    { label: t('Annotated'), value: 'DEFINED' },
    ...(annotationType === 'Brush'
      ? [{ label: t('Empty'), value: 'DEFINED_EMPTY' }]
      : []),
    { label: t('Not annotated'), value: 'UNDEFINED' },
  ]

  const [value, setValue] = useState<SelectOption | undefined>(
    getOption(options, initialValue)
  )

  return (
    <AdvancedSelect
      name="annotationStatusFilter"
      id="annotationStatusFilter"
      isClearable
      label={t('Annotation status')}
      placeholder={t('Filter...')}
      value={value}
      onChange={(v: SelectOption | null) => {
        setValue(v || undefined)
        onChange(v)
      }}
      options={options}
    />
  )
}

export default AnnotationStatusFilter
